import { reactive } from "vue"

export const eventBus = reactive({
  openCart: false
})
